var counters = [
  { id: 'counter0', textBefore: '+', limit: 20, textAfter: 'mil', delay: 70 },
  { id: 'counter1', limit: 99, textBefore: '', textAfter: '%', delay: 20 },
  { id: 'counter2', limit: 30, textBefore: '+', textAfter: '', delay: 60 },
  { id: 'counter3',textBefore: '+', limit: 15, textAfter: ' anos', delay: 80 },
];

function animateCounter(counterId, start, limit, textBefore, textAfter, delay) {
  var counterElement = document.getElementById(counterId);
  var count = start;

  function updateCounter() {
    counterElement.textContent = textBefore + count + textAfter;

    if (count < limit) {
      count++;
      setTimeout(updateCounter, delay);
    }
  }

  updateCounter();
}

function startCounterOnIntersection(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      var counterId = entry.target.id;
      var counterConfig = counters.find(counter => counter.id === counterId);
      animateCounter(counterId, 1, counterConfig.limit, counterConfig.textBefore, counterConfig.textAfter, counterConfig.delay);
    }
  });
}

var observer = new IntersectionObserver(startCounterOnIntersection, { root: null, rootMargin: '0px', threshold: 0.1 });

document.querySelectorAll('.counter').forEach(counter => {
  observer.observe(counter);
});